import { AutogenModelMappingControl, AutogenRowMappingControl } from "./autogen/AutogenModelMappingControl";

export class ModelMappingControl extends AutogenModelMappingControl<RowMappingControl> {
	constructor() {
		super(RowMappingControl);
	}
}

export class RowMappingControl extends AutogenRowMappingControl {
}